import React, { useState } from "react";
import { Link } from "react-router-dom";

import { ReactComponent as User } from "../../Assets/Global/user.svg";
import { ReactComponent as ZixxarLogo } from "../../Assets/Global/zixxar-logo.svg";
import LoginModal from "../LoginModal/LoginModal";

import "./Navbar.scss";

// import { toast } from "react-toastify";
const Navbar = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  const loginModalToggler = () => setShowLoginModal(!showLoginModal);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <>
      <LoginModal show={showLoginModal} toggleModal={loginModalToggler} />

      <nav className="navigation white-color">
        <div className="large-container d-flex align-items-center justify-content-center">
          <Link to="/">
            <ZixxarLogo className="cursor-pointer zixxar-logo" onClick={scrollToTop} />
          </Link>

          <div className="routes-container d-flex align-items-center justify-content-center gap-3 gap-md-5">
            {/* <span
              onClick={() => scrollToTop()}
              className="navigation-link font-size-24 font-pnr pointer">
              Homepage
            </span>
            <span
              className="navigation-link font-size-24 font-pnr pointer"
              onClick={() => window.open("https://event.zixxar.net")}>
              Event
            </span> */}
            {/* <Link to="/join" className="navigation-link font-size-24 font-pnr">
              Join
            </Link> */}
          </div>
          {/* <button className="nav-register-btn" onClick={registerHandler}>
          <div className="inner-container font-size-18 font-pnm">Register</div>
        </button> */}
          {/* <a href="https://beta.zixxar.net/" target="_blank">
            <User className="user-btn" />
          </a> */}

          {/* <User className="user-btn" onClick={() => window.open("https://shop.zixxar.net")} /> */}
        </div>
      </nav>
    </>
  );
};

export default Navbar;
